const NAME = 'zm-loading'
export {
  NAME,
}
